import axios from 'axios';
import Metadata from '../helpers/metadata/Metadata';
import recordDescriptorProcessing  from '../helpers/StoreFunctions/recordDescriptorProcessing';
import serviceUtil from './serviceUtil';
import DataModel from '../models/DataModel';

let helpers = {
  getAttachments() {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/attachments?current_company=' + localStorage.current_company_id,
      // timeout: 20000, headers: {
      //   'Authorization': 'Token token=' + token
      // }
    })
      .then(response => {
        return response.data.attachment;
      })
      .catch(error => {
        return { error: error };
      });
  },
  getAttachment(attachment_id, options) {
    let url = process.env.REACT_APP_API + '/attachments/' + attachment_id + '?current_company=' + localStorage.current_company_id;
    if (options && options.recordDescriptor){
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }
    return axios({
      method: 'get',
      url: url,
      timeout: 20000, headers: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0',
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        if (options && options.recordDescriptor) {
          return response.data;
        }
        else {
          return response.data.attachment;
        }
      })
      .catch(error => {
        return { error: error };
      });
  },
  createAttachment(attachment, eventMetadatum, options, notifyProgressCallback) {
    if (attachment.upload) {
      let data = new FormData();
      data.append('attachment[name]', attachment.name);
      data.append('attachment[upload]', attachment.upload, attachment.upload_name ? attachment.upload_name : attachment.upload.name);
      if (attachment.notes) {
        data.append('attachment[notes]', attachment.notes);
      }
      data.append('attachment[attachable_type]', attachment.attachable_type);
      data.append('attachment[attachable_id]', attachment.attachable_id); 
      data.append('attachment[created_at]', attachment.created_at);
      if (!eventMetadatum) {
        eventMetadatum = Metadata.generateMetadatum();
      }
      data.append('event_metadatum', JSON.stringify(eventMetadatum));
      return axios({
        method: 'post',
        url: process.env.REACT_APP_API + '/attachments?current_company=' + localStorage.current_company_id,
        data: data,
        timeout: 200000, headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Token token=' + localStorage.token,
        },
      })
        .then(response => {
          DataModel.attachmentUploading = false;
          return response.data;
        })
        .catch(error => {
          DataModel.attachmentUploading = false;
          return serviceUtil.resultForError(error);
        });
    }
    else if (attachment.file_upload) {
      return new Promise(function(resolve, reject) {
        let uploadOptions = new window.FileUploadOptions();
        uploadOptions.fileKey = 'upload';
        uploadOptions.fileName = attachment.file_upload.name;
        uploadOptions.mimeType = attachment.file_upload.mime_type;
        uploadOptions.chunkedMode = true;
        uploadOptions.params = {
          attachable_id: attachment.attachable_id,
          attachable_type: attachment.attachable_type,
          created_at: attachment.created_at,
          name: attachment.name,
          upload_file_name: attachment.file_upload.name,
        };
        console.log(uploadOptions);
        uploadOptions.headers = {
          'Authorization': 'Token token=' + localStorage.token,
        };
        let transfer = new window.FileTransfer();
        transfer.onprogress = (progress) => {
          if (progress.lengthComputable) {
            console.log(progress.loaded / progress.total);
          }
          else {
            console.log('progress made!');
          }
          if (notifyProgressCallback) {
            notifyProgressCallback(attachment, progress);
          }
        };
        console.log(transfer);
        transfer.upload(attachment.file_upload.uri, encodeURI(process.env.REACT_APP_API + '/attachments?current_company=' + localStorage.current_company_id), (response) => {
          console.log(response);
          DataModel.attachmentUploading = false;
          resolve(JSON.parse(response.response).data);
        },
          (error) => {
            console.log(error);
            DataModel.attachmentUploading = false;
            reject(serviceUtil.resultForFileTransferError(error));
          }, uploadOptions);
      });
    }
  },
  updateAttachment(attachment, eventMetadatum, options) {
    let data = new FormData();
    console.log('SERVICES UPDATE ATTACHMENT');
    data.append('attachment[name]', attachment.name);
    if (typeof attachment.upload == 'object') {
      data.append('attachment[upload]', attachment.upload, attachment.upload.name);
    }
    else {
      data.append('attachment[upload]', attachment.upload);
    }
    if (attachment.notes) {
      data.append('attachment[notes]', attachment.notes);
    }
    data.append('attachment[attachable_type]', attachment.attachable_type);
    data.append('attachment[attachable_id]', attachment.attachable_id);
    let url = process.env.REACT_APP_API + '/attachments/' + attachment.id + '?current_company=' + localStorage.current_company_id;
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    data.append('event_metadatum', JSON.stringify(eventMetadatum));

    if (options && options.recordDescriptor){
      url += '&filtering=' + recordDescriptorProcessing.getEncodedForFastSerializer(options.recordDescriptor);
    }

    return axios({
      method: 'patch',
      url: url,
      data: data,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  deleteAttachment(attachment_id, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'delete',
      url: process.env.REACT_APP_API + '/attachments/' + attachment_id + '?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response;
      })
      .catch(error => {
        return serviceUtil.resultForError(error);
      });
  },
  fetchBase64(url, taskPage = {}, eventMetadatum) {
    if (!eventMetadatum) {
      eventMetadatum = Metadata.generateMetadatum();
    }
    return axios({
      method: 'post',
      url: process.env.REACT_APP_API + '/pdf-encoder?current_company=' + localStorage.current_company_id,
      data: {
        event_metadatum: eventMetadatum,
        imageUrl: url,
        taskPage: taskPage,
      },
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return { error: error };
      });
  },
  getProjectDocuments(project_id) {
    return axios({
      method: 'get',
      url: process.env.REACT_APP_API + '/attachments/reference_docs_by_project?current_company=' + localStorage.current_company_id + '&project_id=' + project_id,
      timeout: 20000, headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Token token=' + localStorage.token,
      },
    })
      .then(response => {
        return response.data.project;
      })
      .catch(error => {
        return { error: error };
      });
  },
};

export default helpers;



// WEBPACK FOOTER //
// ./src/services/attachmentsService.js